import { type FC } from 'react';
import { Stub, VStack } from '@direct-frontend/components';
import styles from './ClientFormPhoneVerification.module.css';

export const ClientFormPhoneVerificationStub: FC = () => (
    <VStack className={styles.root}>
        <Stub height={24} />

        <Stub height={98} />

        <VStack gap="16" className={styles.buttons}>
            <Stub height={44} />
            <Stub height={44} />
        </VStack>
    </VStack>
);
